import React from 'react';
import Icon from '../../../components/AppIcon';

const ComplianceStatus = () => {
  const complianceData = [
    {
      category: 'Gas Safety Certificates',
      total: 67,
      compliant: 62,
      expiringSoon: 3,
      expired: 2,
      percentage: 92.5,
    },
    {
      category: 'EPC Certificates',
      total: 67,
      compliant: 58,
      expiringSoon: 5,
      expired: 4,
      percentage: 86.6,
    },
    {
      category: 'EICR Certificates',
      total: 67,
      compliant: 60,
      expiringSoon: 4,
      expired: 3,
      percentage: 89.6,
    },
    {
      category: 'Legionella Risk Assessments',
      total: 67,
      compliant: 64,
      expiringSoon: 2,
      expired: 1,
      percentage: 95.5,
    },
  ];

  const getComplianceColor = (percentage) => {
    if (percentage >= 95) return 'var(--color-success)';
    if (percentage >= 85) return 'var(--color-warning)';
    return 'var(--color-error)';
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground font-heading">Compliance Overview</h3>
        <div className="flex items-center gap-2">
          <Icon name="ShieldCheck" size={20} color="var(--color-success)" />
          <span className="text-sm font-medium text-success font-caption">91.1% Overall</span>
        </div>
      </div>
      <div className="space-y-4">
        {complianceData?.map((item, index) => (
          <div key={index} className="p-4 rounded-lg bg-input border border-border">
            <div className="flex items-center justify-between mb-3">
              <h4 className="text-sm font-medium text-foreground font-caption">{item?.category}</h4>
              <span 
                className="text-sm font-bold font-data"
                style={{ color: getComplianceColor(item?.percentage) }}
              >
                {item?.percentage?.toFixed(1)}%
              </span>
            </div>

            <div className="w-full h-2 bg-surface rounded-full overflow-hidden mb-3">
              <div 
                className="h-full rounded-full transition-all duration-300"
                style={{ 
                  width: `${item?.percentage}%`,
                  backgroundColor: getComplianceColor(item?.percentage)
                }}
              />
            </div>

            <div className="grid grid-cols-4 gap-2 text-xs">
              <div className="text-center">
                <p className="text-muted-foreground font-caption">Total</p>
                <p className="font-medium text-foreground font-data">{item?.total}</p>
              </div>
              <div className="text-center">
                <p className="text-muted-foreground font-caption">Compliant</p>
                <p className="font-medium text-success font-data">{item?.compliant}</p>
              </div>
              <div className="text-center">
                <p className="text-muted-foreground font-caption">Expiring</p>
                <p className="font-medium text-warning font-data">{item?.expiringSoon}</p>
              </div>
              <div className="text-center">
                <p className="text-muted-foreground font-caption">Expired</p>
                <p className="font-medium text-error font-data">{item?.expired}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComplianceStatus;